module.exports = "<input type=hidden :name=inputName v-for=\"input in inputValue\" :value=inputValue />";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/hidden/hidden.vue
// module id = 448
// module chunks = 0